// extracted by mini-css-extract-plugin
export default {"Shelf":"yGHtwkts","Spacer":"v1QJVpui"};